import { CSSProperties } from 'react'

export const PaperStyle: CSSProperties = {
  background: '#F3F5F7',
  padding: 2,
}

export const PrimaryTagStyle: CSSProperties = {
  background: '#D4E3F3',
}

export const OutlinedPaperStyle: CSSProperties = {
  padding: 2,
}

export const SecondaryTagStyle: CSSProperties = {
  background: '#091B2A14',
}

export const MainProgressBarStyle: CSSProperties = {
  borderRadius: '2px',
  height: 8,
}

export const SubProgressBarStyle: CSSProperties = {
  borderRadius: '2px',
  height: 4,
}
